/*----------  Global Variables  ----------*/

let wWidth;
let wHeight;

/*----------  Document Ready  ----------*/

$(document).ready(() => {
	wWidth = $(window).width();
	wHeight = $(window).height();

	initSmoothScroll();
	console.log('Ready!');
});

/*----------  Window Events  ----------*/

$(window).on('load resize', () => {
	wWidth = $(window).width();
	wHeight = $(window).height();
});

function initSmoothScroll()
{
	$('.smooth-scroll').on('click', function(event) {
		event.preventDefault();
		$('body, html').animate({
	        scrollTop: $($(this).attr('href')).offset().top// - $('header').outerHeight()
	    }, 500);
	});
}